import SportPositionTypes from "./SportPositionTypes";
export default SportPositionTypes;
